import {
  roleOptions,
  interestOptions,
  registrationTypeOptions,
  activityTypeOptions,
  receiveMarketingEmailsOptions,
  receiveNewsEmailsOptions,
  receiveEventsEmailsOptions,
} from 'constants/winlover-filters';
import WineLoversActivitiesService from 'services/wineLoversActivitiesService';
import {
  adaptWineLoversActivitiesPartnerFilter,
  adaptWineLoversActivitiesMenuFilter,
  adaptWineLoversActivitiesWineFilter,
  adaptWineLoversActivitiesProducerFilter,
  adaptWineLoversActivitiesVintageFilter,
  adaptWineLoversActivitiesCountryFilter,
  adaptWineLoversActivitiesStateFilter,
} from 'helpers/adapter';
import Activity from '../commonCellComponent/activity/Activity';

const tableOptions = {
  wineLoversActivities: {
    fields: [
      {
        id: 'activity_type',
        label: 'table.wineLoversActivities.activityType',
        component: Activity,
        type: 'customComponent',
        sortable: true,
        cellPaddingLeft: '24px',
        minWidth: '150px',
      },
      {
        id: 'activity_timestamp',
        label: 'table.wineLoversActivities.activityDateTime',
        type: 'text',
        sortable: true,
        minWidth: '150px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'partner_name',
        label: 'table.wineLoversActivities.partnerName',
        type: 'text',
        sortable: true,
        minWidth: '170px',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'producer',
        label: 'table.wineLoversActivities.producer',
        type: 'text',
        sortable: true,
        minWidth: '170px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'wine_name',
        label: 'table.wineLoversActivities.wineName',
        type: 'text',
        sortable: true,
        minWidth: '170px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'vintage',
        label: 'table.wineLoversActivities.vintage',
        type: 'text',
        sortable: true,
        minWidth: '50px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'rating',
        label: 'table.wineLoversActivities.rating',
        type: 'text',
        sortable: true,
        minWidth: '50px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'menu_name',
        label: 'table.wineLoversActivities.wineList',
        type: 'text',
        sortable: true,
        minWidth: '170px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'user_name',
        label: 'table.wineLoversActivities.userName',
        type: 'text',
        sortable: true,
        minWidth: '170px',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'user_email',
        label: 'table.wineLoversActivities.userEmail',
        type: 'text',
        sortable: true,
        minWidth: '170px',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'user_id',
        label: 'table.wineLoversActivities.id',
        type: 'text',
        sortable: true,
        minWidth: '80px',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'role',
        label: 'table.wineLoversActivities.userType',
        type: 'text',
        sortable: true,
        minWidth: '150px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'registration_type',
        label: 'table.wineLoversActivities.registrationType',
        type: 'text',
        sortable: true,
        minWidth: '100px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'country',
        label: 'table.wineLoversActivities.country',
        type: 'text',
        sortable: true,
        minWidth: '150px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'state',
        label: 'table.wineLoversActivities.state',
        type: 'text',
        sortable: true,
        minWidth: '110px',
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'marketing_enabled',
        label: 'table.wineLoversActivities.receiveMarketingEmails',
        type: 'text',
        sortable: true,
        minWidth: '40px',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'receive_news_emails',
        label: 'table.wineLoversActivities.receiveNewsEmails',
        type: 'text',
        sortable: true,
        minWidth: '100px',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
      {
        id: 'receive_events_emails',
        label: 'table.wineLoversActivities.receiveEventsEmails',
        type: 'text',
        sortable: true,
        minWidth: '100px',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
        cellPaddingLeft: '12px',
        cellPaddingRight: '12px',
      },
    ],
    rowsPerPageOptions: [5, 10, 25, 50, 100],
    filterFields: [
      {
        id: 'activity_type',
        label: 'table.wineLoversActivities.filter.activityType.title',
        type: 'custom-multi-autocomplete',
        options: activityTypeOptions,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'activity_timestamp',
        label: 'table.wineLoversActivities.filter.activityDateTime.title',
        type: 'dateRange',
        priority: 1,
        selectedClassName: 'colorizeSelected',
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'partner_name',
        label: 'table.wineLoversActivities.filter.partner',
        type: 'custom-multi-autocomplete',
        options: WineLoversActivitiesService.getWineLoversActivitiesPartnerFilter,
        adapterCallback: adaptWineLoversActivitiesPartnerFilter,
        optionsType: 'string',
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
      },
      {
        id: 'producer',
        label: 'table.wineLoversActivities.filter.producer',
        type: 'custom-multi-autocomplete',
        options: WineLoversActivitiesService.getWineLoversActivitiesProducerFilter,
        adapterCallback: adaptWineLoversActivitiesProducerFilter,
        optionsType: 'string',
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'wine_name',
        label: 'table.wineLoversActivities.filter.wineName',
        type: 'custom-multi-autocomplete',
        options: WineLoversActivitiesService.getWineLoversActivitiesWineFilter,
        adapterCallback: adaptWineLoversActivitiesWineFilter,
        optionsType: 'string',
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'vintage',
        label: 'table.wineLoversActivities.filter.vintage',
        type: 'custom-multi-autocomplete',
        options: WineLoversActivitiesService.getWineLoversActivitiesVintageFilter,
        adapterCallback: adaptWineLoversActivitiesVintageFilter,
        optionsType: 'string',
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'rating',
        label: 'table.wineLoversActivities.filter.rating.title',
        type: 'numberRange',
        priority: 1,
        selectedClassName: 'colorizeSelected',
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'menu_name',
        label: 'table.wineLoversActivities.filter.wineList',
        type: 'custom-multi-autocomplete',
        options: WineLoversActivitiesService.getWineLoversActivitiesMenuFilter,
        adapterCallback: adaptWineLoversActivitiesMenuFilter,
        optionsType: 'string',
        priority: 1,
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
      },
      {
        id: 'role',
        label: 'table.wineLoversActivities.filter.role.title',
        type: 'custom-multi-autocomplete',
        options: roleOptions,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'registration_type',
        label: 'table.wineLoversActivities.filter.registrationType.title',
        type: 'custom-multi-autocomplete',
        options: registrationTypeOptions,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'interests',
        label: 'table.wineLoversActivities.filter.interests.title',
        type: 'custom-multi-autocomplete',
        options: interestOptions,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'country',
        label: 'table.wineLoversActivities.filter.country',
        type: 'custom-multi-autocomplete',
        options: WineLoversActivitiesService.getWineLoversActivitiesCountryFilter,
        adapterCallback: adaptWineLoversActivitiesCountryFilter,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'state',
        label: 'table.wineLoversActivities.filter.state',
        type: 'custom-multi-autocomplete',
        options: WineLoversActivitiesService.getWineLoversActivitiesStateFilter,
        adapterCallback: adaptWineLoversActivitiesStateFilter,
        priority: 1,
        optionsType: 'string',
        optionsWithCheckbox: true,
        selectedClassName: 'colorizeSelected',
        sortBySelected: true,
        isAvailable: ({ isUserSuperAdmin, subscriptionAccess }) => isUserSuperAdmin || !!subscriptionAccess.activity,
      },
      {
        id: 'marketing_enabled',
        label: 'table.wineLoversActivities.filter.receiveMarketingEmails.title',
        type: 'select',
        options: receiveMarketingEmailsOptions,
        priority: 1,
        optionsWithCheckbox: false,
        selectedClassName: 'colorizeSelected',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
      },
      {
        id: 'receive_news_emails',
        label: 'table.wineLoversActivities.filter.receiveNewsEmails.title',
        type: 'select',
        options: receiveNewsEmailsOptions,
        priority: 1,
        optionsWithCheckbox: false,
        selectedClassName: 'colorizeSelected',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
      },
      {
        id: 'receive_events_emails',
        label: 'table.wineLoversActivities.filter.receiveEventsEmails.title',
        type: 'select',
        options: receiveEventsEmailsOptions,
        priority: 1,
        optionsWithCheckbox: false,
        selectedClassName: 'colorizeSelected',
        show: ({ isUserSuperAdmin }) => isUserSuperAdmin,
      },
    ],
    searchFields: ['user_id', 'user_name', 'user_email'],
    searchFieldsAvailable: ({ isUserSuperAdmin }) => isUserSuperAdmin,
  },
};

export default tableOptions;
